import { State } from '../state.interface';
import * as Actions from '../actions';
import { assocPath } from 'ramda';

export const setDisplayNameReducer = (state: State, action: Actions.SetDisplayName) =>
  assocPath(['variableConfiguration', 'display_name'], action.payload.displayName, state);
